//import React from 'react'
import { Container } from "react-bootstrap";
import { Outlet } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";

import Footer from "./components/Footer";

import bgImage from "./assets/zpotterGymBG.jpg";
import { useEffect, useState } from "react";

const App = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [mobileScreen, setMobileScreen] = useState(window.innerWidth < 600);
  // const bgImage =
  //   "https://zpottergym.s3.ap-south-1.amazonaws.com/GymProfilePic/gymProfilePic2.jpg";
  useEffect(() => {
    const handleResize = () => {
      setMobileScreen(window.innerWidth < 600);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [expandMenu, setExpandMenu] = useState(true);

  return (
    <>
      <main
        style={{
          height: "100vh",
          backgroundAttachment: "fixed",
          overflow: "scroll",
          backgroundColor: "#ecf3f2",
          backgroundImage: `url(${bgImage})`, // Corrected: Use backticks and template literal to reference the variable
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <ToastContainer position="top-center" autoClose="3000" />
        <Container>
          <Outlet />
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default App;
